var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.EewcNotificationDialog,{attrs:{"icon-color":_vm.iconColor,"show-progress":true,"icon":_vm.icon,"showing":_vm.showing,"body":_vm.body,"title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }